import React from "react";
import { Box } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import ClientDataGrid from "./ClientDataGrid";
import EmptyClients from "./EmptyClients";
import { aggregatedClientsState } from "../../../../hooks/useClientsAggregate";
import { useRecoilValue } from "recoil";

const ClientTable = ({
  onAddClientClicked,
  onClientClicked,
  deleteClientClicked,
  editClientClicked,
  additionalInfo,
  clients: clientsProp,
}) => {
  const clientsFromState = useRecoilValue(aggregatedClientsState);
  // Use provided clients prop if available, otherwise use state
  const clients = clientsProp !== undefined ? clientsProp : clientsFromState;

  // Show empty state when there are no clients
  if (clients.length === 0) {
    return (
      <EmptyClients
        onAddClient={() => {
          if (onAddClientClicked) {
            onAddClientClicked(true);
          }
        }}
      />
    );
  }

  return (
    <>
      {onAddClientClicked && (
        <Box
          style={{ marginRight: 24, marginBottom: 12 }}
          display="flex"
          justifyContent="flex-end"
        >
          <StandardButton
            variant="primary"
            onClick={() => {
              if (clients.length === 0) {
                if (onAddClientClicked) {
                  onAddClientClicked(true);
                }
                return;
              }

              if (onAddClientClicked) {
                onAddClientClicked(true);
              }
            }}
          >
            Add New Client
          </StandardButton>
        </Box>
      )}
      <Box sx={{ flex: 1 }}>
        <ClientDataGrid
          additionalInfo={additionalInfo}
          clients={clients}
          onClick={(client) => {
            if (onClientClicked) {
              onClientClicked(client);
            }
          }}
          onDelete={(client) => {
            if (deleteClientClicked) {
              deleteClientClicked(client);
            }
          }}
          onEdit={(client) => {
            if (editClientClicked) {
              editClientClicked(client);
            }
          }}
        />
      </Box>
    </>
  );
};

export default ClientTable;
